// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3gNr5","signatureButtonsRight":"ModalSign_signatureButtonsRight__2TiHT"};